export const SHOW_NOTIFICATION = 'showNotification';
export const CHANGE_DOC_TITLE = 'changeDocTitle';
export const PENDING = 'pending';
